export const HELP_CENTRE_URL = 'https://help.vatix.com/';
export const WHATS_NEW_URL = 'https://help.vatix.com/product-updates';
export const SERVICE_USER_TERMS_URL = 'https://www.vatix.com/legal/service-user-terms';
